import logo from "../images/cover.jpeg"
import "./styles.scss"

const Navbar = () => {
    return (
        <div className="nav-bar">
            <h1>KiteWallah</h1>
            <img src={logo} alt="logo" />
            <ul className="nav-list">
                <li>Kites</li>
                <li>Maanja</li>
                <li className="contact-us">Call 7097926412</li>
            </ul>
        </div>)
}

export default Navbar